// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1oZ4H","label":"Section_label__21QKA","contentWrap":"Section_contentWrap__ceL5x","footer":"Section_footer__25sUR","footerInner":"Section_footerInner__3dsx0"};